import nBossConnection from 'modules/base/service/nBossConnection';

class EdtDynamicCheckService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'edtDynamicCheckControl';
	}

	/**
	 * @return {Promise<NamedDto[]>}
	 */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @param {Object} base_state
	* @param {Object} best_state
	* @return {Promise<Object>}
	*/
	start(id, base_state, best_state) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/start`, {
					id,
					baseValues: JSON.stringify(base_state),
					bestValues: JSON.stringify(best_state)
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @return {Promise<Object>}
	*/
	terminate(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/terminate`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new EdtDynamicCheckService();